import * as actionTypes from 'actions';

const initialState = {
  loading: false,
  reportEntries: [],
  lastUpdatedTime: null,
  mininumWalkCount: 50
};

const venueMonitorListReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.VENUE_MONITOR_LIST_PENDING: {
      return {
        ...state,
        loading: true
      };
    }

    case actionTypes.VENUE_MONITOR_LIST_FULFILLED: {
      return {
        ...state,
        loading: false,
        reportEntries: action.payload.data.result,
        lastUpdatedTime: new Date().getTime()
      };
    }

    case actionTypes.SET_VENUE_MONITOR_LIST_MINIMUM_WALK_COUNT: {
      return {
        ...state,
        mininumWalkCount: action.payload
      };
    }

    default: {
      return state;
    }
  }
};

export default venueMonitorListReducer;
